import { useEffect, useState } from "react";
import { useEpisodes } from "../../../../../Recoil/Novel/Episode";
import "./EpisodeFooter.scss";
import { Button } from "@mui/material";
import { fn, isAgeAdult } from "../../../../../Functions";
import { logBehavior } from "../../../../../Data/Behavior";
import { useToastAlert } from "design-system/Toast";

import '../../../../../Components/Styles/NudgeDialog.scss';
import AgeVerificationDialog from "../../../../../Components/AgeVerificationDialog";
import { useUsers } from "../../../../../Recoil/User/User";
import { useSession } from "../../../../../Recoil/Session/Session";

const EpisodeFooter = ({
    title, episode,
}:{
    title: TitleType & TitleAugmentedData, episode: EpisodeType,
}) => {
    const { toastAlert } = useToastAlert();

    const {serviceId, titleId} = title;
    const { episodeObject } = useEpisodes();
    const {userObject, fetch: fetchUser} = useUsers();
    const {session} = useSession();

    const currentIdx = episodeObject[`${serviceId}:${titleId}`]?.findIndex( ep => ep.episodeId === episode.episodeId );
    const nextEpisode = episodeObject[`${serviceId}:${titleId}`]?.[currentIdx + 1];

    const [timeForSale, setTimeForSale] = useState(0);
    const [showAgeVerification, setShowAgeVerification] = useState(false);

    useEffect(() => {
        fetchUser([session?.userid ?? ""]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[session]);

    useEffect(()=>{
        let firstReadTime = JSON.parse(localStorage.getItem("firstReadTime") || "0");

        if (firstReadTime === 0){
            firstReadTime = Math.floor(Date.now() / 1000);
            localStorage.setItem("firstReadTime", JSON.stringify(firstReadTime));
        }
    
        const interval = setInterval(()=>{
            setTimeForSale(1800 - (Math.floor(Date.now() / 1000) - firstReadTime));

            if ((Math.floor(Date.now() / 1000) - firstReadTime) > 1800) {
                localStorage.removeItem("promotionCode");
                clearInterval(interval);
            }
        }, 1000);

        return () => {
            clearInterval(interval);
        }
    },[]);

    const passedMinute = Math.floor(timeForSale / 60);
    const passedSecond = timeForSale % 60;
    
    // Check if age verification is needed
    const needsAgeVerification = (episode: EpisodeType): boolean => {
        if (!title?.isAdult || !episode || episode.isFree) {
            return false;
        }
        
        return !isAgeAdult(new Date(userObject[session?.addressid ?? ""]?.certificatedBirthday ?? new Date()));
    };

    return (<div className={"EpisodeFooterArea"} >
        <div className={"EpisodeFooterInner"} >
            <div className={"TitleBox"} >
                <div className={"Title"}>
                    {title.title}
                </div>
                <div className={"Genre"}>
                    {title.tags.split(",").join(" · ")}
                </div>
            </div>
            {nextEpisode
            ?<div className={"ButtonBucket"}>
                {(nextEpisode.isFree || title.timeRemain > 0)
                ?<Button className={"NextEpisodeButton"}
                    onClick={(e) =>{
                        logBehavior("clickNextEpisode", {serviceId, titleId, episodeId: nextEpisode.episodeId, pixel: "Lead"});
                        fn.gotoByAnchor(e);
                    }}
                    href={`/contents/${serviceId}/${titleId}/${nextEpisode.episodeId}`}
                >
                    <img src={nextEpisode.thumbnail || title.thumbnail} className={"Thumbnail"} alt={`${episode.title}-Footer`} />
                    <div className={"NextEpisodeBox"}>
                        <div className={"Title"}>
                            {`다음화 무료로 보기`}
                        </div>
                        <div className={"NextEpisodeTitle"}>
                            {nextEpisode.title}
                        </div>
                    </div>
                    <img src="https://static.novela.today/icon/chevron_right_thick.svg" alt='arrow' width={24} height={24}/>
                </Button>
                :needsAgeVerification(nextEpisode)
                ?<Button className={"NextEpisodeButton"}
                    onClick={(e) =>{
                        logBehavior("clickNextEpisode", {serviceId, titleId, episodeId: nextEpisode.episodeId, pixel: "Lead"});
                        logBehavior('click-payment-endof-free-ep', {serviceId, titleId});
                        logBehavior('click-adult-endof-free-ep', {serviceId, titleId});
                        
                        setShowAgeVerification(true);
                    }}
                >
                    <img src={nextEpisode.thumbnail || title.thumbnail} className={"Thumbnail"} alt={`${episode.title}-Footer`} />
                    <div className={"NextEpisodeBox"}>
                        <div className={"Title"}>
                            {`다음화 보기`}
                        </div>
                        <div className={"NextEpisodeTitle"}>
                            {nextEpisode.title}
                        </div>
                    </div>
                    <img src="https://static.novela.today/icon/chevron_right_thick.svg" alt='arrow' width={24} height={24}/>
                </Button>
                :<Button className={"NextEpisodeButton"}
                    onClick={(e) =>{
                        logBehavior("clickNextEpisode", {serviceId, titleId, episodeId: nextEpisode.episodeId, pixel: "Lead"});
                        logBehavior('click-payment-endof-free-ep', {serviceId, titleId});
                        toastAlert("해당 회차는 열람권 구매가 필요합니다.", 3000, "info");
                        fn.gotoByAnchor(e);
                    }}
                    href={`/payment/${serviceId}/${titleId}`}
                >
                    <img src={nextEpisode.thumbnail || title.thumbnail} className={"Thumbnail"} alt={`${episode.title}-Footer`} />
                    <div className={"NextEpisodeBox"}>
                        <div className={"Title"}>
                            {`다음화 보기`}
                        </div>
                        <div className={"NextEpisodeTitle"}>
                            {nextEpisode.title}
                        </div>
                    </div>
                    <img src="https://static.novela.today/icon/chevron_right_thick.svg" alt='arrow' width={24} height={24}/>
                </Button>}
                {timeForSale > 0 && title.timeRemain === 0 &&
                <Button className={"DiscountBox"}
                    onClick={(e) => {
                        localStorage.setItem("promotionCode", "10p");
                        logBehavior('click-payment-discountbox', {serviceId, titleId});
                        fn.gotoByAnchor(e);
                    }}
                    href={`/payment/${serviceId}/${titleId}`}
                >
                    <div className={"DiscountBand"}>
                        <div className={"BandContent"} >
                            <div className={"GiftBox"} >
                                <img className={"GiftIcon"} src="https://static.novela.today/icon/animated_GIFT.png" alt='gift' width={24} height={24}/>
                            </div>
                            <div className={"DiscountTextBox"} >
                                <div className={"ColoredText"} >{"특별한 할인 혜택"}</div>
                                <div >{`남은 시간 ${passedMinute}분 ${passedSecond}초`}</div>
                                <div className={"ColoredText"}  >{""}</div>
                            </div>
                        </div>
                        <img src="https://static.novela.today/icon/chevron_right_thick.svg" alt='arrow' width={24} height={24}/>
                    </div>
                    <div className={"DiscountInfo"}> 
                        {"지금을 놓치면 할인 혜택을 받을 수 없어요!"}
                    </div>
                </Button>}
            </div>
            :<span>{"마지막화입니다."}</span>}
        </div>
        {serviceId && titleId && /* Age Verification Dialog */
        <AgeVerificationDialog
            serviceId={serviceId || ""}
            titleId={titleId || ""}
            open={showAgeVerification}
            onClose={()=>{
                setShowAgeVerification(false);
            }}
            onSuccess={()=>{
                setShowAgeVerification(false);
                logBehavior('age-verification-complete', { serviceId, titleId, });
                fn.goto(`/payment/${serviceId}/${titleId}`);
            }}
        />}
      
    </div>)
}

export default EpisodeFooter;